import React, {useState, useRef} from "react";
import emailjs from "@emailjs/browser";
import "./Contact.scss";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import hajjiimage from "../../assets/images/me.png";

const EMAILJS_SERVICE_ID  = "service_fvjmyav";
const EMAILJS_TEMPLATE_ID = "template_v4dr1tm";
const EMAILJS_PUBLIC_KEY  = "8cmnBWu0gbfMykmoi";

export default function Contact() {
  const formRef = useRef(null);
  const [form, setForm] = useState({from_name: "", from_email: "", message: ""});
  const [status, setStatus] = useState("idle");

  const handleChange = e => setForm({...form, [e.target.name]: e.target.value});

  const handleSubmit = e => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setStatus("success");
        setForm({from_name: "", from_email: "", message: ""});
        setTimeout(() => setStatus("idle"), 5000);
      })
      .catch(() => {
        setStatus("error");
        setTimeout(() => setStatus("idle"), 4000);
      });
  };

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-section" id="contact">

        {/* ── Title — above both columns ── */}
        <div className="contact-header">
          <p className="contact-eyebrow">Let's work together</p>
          <h1 className="contact-title">Contact Me</h1>
        </div>

        <div className="contact-wrapper">

          {/* ── Left: photo card ── */}
          <div className="contact-left">
            <div className="contact-photo-wrap">
              <div className="contact-photo-ring" />
              <div className="contact-photo-ring contact-photo-ring--2" />
              <img
                src={hajjiimage}
                alt="Hajji Mohamed Amine"
                className="contact-photo"
              />
              <div className="contact-badge">
                <span className="contact-badge-dot" />
                Available for hire
              </div>
            </div>

            <div className="contact-links">
              {contactInfo.number && (
                <a href={`tel:${contactInfo.number}`} className="contact-link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.06 6.06l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  {contactInfo.number}
                </a>
              )}
              <a href={`mailto:${contactInfo.email_address}`} className="contact-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
                {contactInfo.email_address}
              </a>
            </div>
          </div>

          {/* ── Right: form card ── */}
          <form ref={formRef} className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="from_name"
                  placeholder="Your full name"
                  value={form.from_name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="from_email"
                  placeholder="your@email.com"
                  value={form.from_email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Message</label>
              <textarea
                name="message"
                placeholder="Tell me about your project or idea..."
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
                className="form-input form-textarea"
              />
            </div>

            <div className="form-footer">
              <button
                type="submit"
                className={`form-submit ${status}`}
                disabled={status === "sending"}
              >
                {status === "sending" && <span className="form-spinner" />}
                {status === "sending"  ? "Sending…"
                 : status === "success" ? "✓ Message sent!"
                 : status === "error"   ? "Error — try again"
                 : (
                  <>
                    Send Message
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                    </svg>
                  </>
                 )}
              </button>
              {status === "success" && (
                <p className="form-feedback success">Got it! I'll get back to you shortly.</p>
              )}
              {status === "error" && (
                <p className="form-feedback error">Something went wrong. Please set up the EmailJS keys in Contact.js or reach out directly.</p>
              )}
            </div>

            <div className="form-glow" />
          </form>

        </div>
      </div>
    </Fade>
  );
}
